import React from 'react';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import { PortfolioReturnsData } from '../chart/portfolioReturnsData';
import { PortfolioReturnsConfigurationState } from '../store/configuration/PortfolioReturnsConfigurationState';
import { deriveLegendData } from './portfolioReturnsLegendsData';
import PortfolioReturnsLegend from './PortfolioReturnsLegend';
import { PortfolioReturnsComponentState } from '../store/component/PortfolioReturnsComponentState';
import PortfolioReturnsIndexLegends from './PortfolioReturnsIndexLegends';
import PortfolioReturnsHelp from 'widgets/portfolioReturns/help/PortfolioReturnsHelp';
import { usePortfolioReturnsLegendStatus } from 'widgets/portfolioReturns/legends/legendStatus';
import classNames from 'classnames';
import { useSelectLocked } from 'layoutRenderer/store/selectors';

interface PortfolioReturnsLegendsProps {
    combineSellsAndShorts: boolean;
    config: PortfolioReturnsConfigurationState;
    componentState: PortfolioReturnsComponentState;
    data: PortfolioReturnsData;
    width: number;
}

export default function PortfolioReturnsLegends(
    props: PortfolioReturnsLegendsProps
) {
    const { data, combineSellsAndShorts, config } = props;
    const time = usePointedTime('PortfolioReturnsLegend');

    const isLocked = useSelectLocked();
    const legendData = deriveLegendData(data, time);

    const { allHidden, columnCount } = usePortfolioReturnsLegendStatus();

    const legendCountClass = 'legend-count-' + columnCount;

    const allowLegendVisibilityEditing = isLocked;

    if (allHidden) {
        return <></>;
    }

    const cssClasses = classNames(
        'PortfolioReturnsLegends',
        legendCountClass,
        allowLegendVisibilityEditing && 'allow-legend-visibility-editing'
    );

    return (
        <div className={cssClasses}>
            <PortfolioReturnsLegend
                alignDropdown={'left'}
                hideSeriesPropertyName={'hideBuy'}
                label="Buy"
                value={legendData.buy}
            />
            <PortfolioReturnsLegend
                hideSeriesPropertyName={'hideSell'}
                label="Sell"
                value={legendData.sell}
            />
            {!combineSellsAndShorts && (
                <PortfolioReturnsLegend
                    hideSeriesPropertyName={'hideShort'}
                    label="Shorts"
                    value={legendData.short}
                />
            )}
            {data.multipleSides && !config.invertSellLine && (
                <PortfolioReturnsLegend
                    alignDropdown={'right'}
                    label="Total"
                    hideSeriesPropertyName={'hideTotal'}
                    value={legendData.total}
                />
            )}
            {(config.index1 || config.index2) && (
                <PortfolioReturnsIndexLegends
                    index1Config={config.index1}
                    index2Config={config.index2}
                    index1Value={legendData.index1}
                    index2Value={legendData.index2}
                />
            )}
            <PortfolioReturnsHelp />
        </div>
    );
}
